var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-pane"},[_c('transition',{attrs:{"name":_vm.paneTransitionName}},[(_vm.$parent.activeName === _vm.name)?_c('div',{key:_vm.$parent.activeName,staticClass:"tab-pane-content"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }